export default {"src":"/_next/static/media/accountSettings.57d068de.svg","height":65,"width":75};